import type { IconType } from 'react-icons';

import styles from './Suggestions.module.css';

interface SuggestionItem {
  id: string;
  label: string;
  icon: IconType;
}

interface Props {
  items: readonly SuggestionItem[];
  onPick: (id: string) => void;
}

export function Suggestions({ items, onPick }: Props) {
  return (
    <div className={styles.suggestions}>
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          className={styles.suggestion}
          onClick={() => onPick(item.id)}
        >
          <item.icon className={styles.icon} aria-hidden />
          <span>{item.label}</span>
        </button>
      ))}
    </div>
  );
}
